import { callExternalApi } from "../../../services/external-api.service";

class SchedulerHttpClient {

    _apiServerUrl;

    constructor(apiServerUrl = process.env.REACT_APP_API_ORIGIN) {
        this._apiServerUrl = `${apiServerUrl}/v2`;
    }

    

    async getSchedulers(projectTag: string, accessToken: any) {
        const config = {
            url: `${this._apiServerUrl}/project/${projectTag}/schedulers`,
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${accessToken}`,
            },
        };

        const { data, error } = await callExternalApi({ config });

        return {
            data: data.data || null,
            error,
        };
    }

    async getSchedulerByType(projectTag: string, type: string, accessToken: any) {
        const config = {
            url: `${this._apiServerUrl}/project/${projectTag}/scheduler/type/${type}`,
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${accessToken}`,
            },
        };

        const { data, error } = await callExternalApi({ config });

        return {
            data: data.data || null,
            error,
        };
    }

    async createScheduler(projectTag: string, schedulerData: any, accessToken: any) {
        const config = {
            url: `${this._apiServerUrl}/project/${projectTag}/scheduler`,
            method: "POST",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${accessToken}`,
            },
            data: schedulerData,
        };

        const { data, error } = await callExternalApi({ config });

        return {
            data: data.data || null,
            error,
        };
    }

    async updateScheduler(projectTag: string, schedulerUuid: string, schedulerData: any, accessToken: any) {
        const config = {
            url: `${this._apiServerUrl}/project/${projectTag}/scheduler/${schedulerUuid}`,
            method: "PUT",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${accessToken}`,
            },
            data: schedulerData,
        };

        const { data, error } = await callExternalApi({ config });

        return {
            data: data.data || null,
            error,
        };
    }

    async deleteScheduler(projectTag: string, schedulerUuid: string, accessToken: any) {
        const config = {
            url: `${this._apiServerUrl}/project/${projectTag}/scheduler/${schedulerUuid}`,
            method: "DELETE",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${accessToken}`,
            },
        };

        const { data, error } = await callExternalApi({ config });

        return {
            data: data.data || null,
            error,
        };
    }

    async getPublicSchedulerByType(projectTag: string, schedulerType: string) {
        const config = {
            url: `${this._apiServerUrl}/project/${projectTag}/scheduler/public/${schedulerType}`,
            method: "GET",
            headers: {
                "content-type": "application/json",
            },
        };

        const { data, error } = await callExternalApi({ config });

        return {
            data: data.data || null,
            error,
        };
    }

    async createPublicMeeting(projectTag: string, schedulerUuid: string, calendlyData: { calendlyEventUri: string, calendlyInviteeUri: string}, advisorData: { advisorPublicId: string | null, surveyLinkPublicId: string | null }) {
        const config = {
            url: `${this._apiServerUrl}/project/${projectTag}/scheduler/public/${schedulerUuid}/meeting`,
            method: "POST",
            headers: {
                "content-type": "application/json",
            },
            data: {
                calendly_event_uri: calendlyData.calendlyEventUri,
                calendly_invitee_uri: calendlyData.calendlyInviteeUri,
                advisor_public_id: advisorData.advisorPublicId,
                survey_link_public_id: advisorData.surveyLinkPublicId,
            },
        };

        const { data, error } = await callExternalApi({ config });

        return {
            data: data.data || null,
            error,
        };
    }

    async refreshMeeting(meetingUuid: string) {
        const config = {
            url: `${this._apiServerUrl}/meeting/${meetingUuid}/refresh`,
            method: "POST",
        };

        const { data, error } = await callExternalApi({ config });

        return {
            data: data.data || null,
            error,
        };
    }
}

export default SchedulerHttpClient;